
<div class="form-group">
  @if (showLabel && (question?.question_prompt || question?.question_copy || question?.email_version || labelText)) {
    <label class="form-group__label">
      {{useQuestionPromptLabel ? question?.question_prompt : question?.question_copy || question?.email_version || labelText}}
    </label>
  }
  @if (range?.min !== range?.max) {
    <div class="form-group form-group--sm">
      <div class="custom-rangeslider custom-rangeslider--lg">
        <div class="custom-rangeslider__control" [id]="'slider' + uniqueId"></div>
        <div class="custom-rangeslider__input">
          <input class="form-control" type="text" [readonly]="readOnly" [id]="'sliderinput' + uniqueId"
            (change)="onInputChange($event)">
          </div>
        </div>
      </div>
    }
    @if (range?.min === range?.max) {
      <input [value]="questionService?.accounting?.formatMoney(this.question.answer)" class="form-control" [id]="'textbox-' + uniqueId" disabled="" style="text-align: left;">
    }
  </div>
